import { render, staticRenderFns } from "./MilestoneWrapper.vue?vue&type=template&id=8a741ca6&"
import script from "./MilestoneWrapper.vue?vue&type=script&lang=js&"
export * from "./MilestoneWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports